import type { Color, PieceType } from "../game/types";

const ICONS: Record<Color, Record<PieceType, string>> = {
  w: { p: "♙", n: "♘", b: "♗", r: "♖", q: "♕", k: "♔" },
  b: { p: "♟", n: "♞", b: "♝", r: "♜", q: "♛", k: "♚" },
};

export function pieceIcon(color: Color, type: PieceType): string {
  return ICONS[color][type];
}

export const PIECE_NAMES_FR: Record<PieceType, string> = {
  p: "Pion",
  n: "Cavalier",
  b: "Fou",
  r: "Tour",
  q: "Dame",
  k: "Roi",
};
